import React, {useEffect} from 'react';
import {shallowEqual, useSelector, useIntl, history, useLocation} from 'umi';
import {useMemoizedFn} from 'ahooks';
import { Layout, notification } from 'tea-component';
import QuickAnalysis from "@/pages/datalab/pages/Home/QuickAnalysis";
import GettingStart from '@/pages/datalab/pages/Home/GettingStart';
import {buriedPoint} from '@home/utils/buriedPoint';

import './index.scss';
import RecentlyAndShare from '@/pages/datalab/pages/Home/RecentlyAndShare';

const { Body, Content } = Layout;
export default function Home() {
  const {formatMessage} = useIntl();
  const {gameCode, allPrivileges} = useSelector((state: any) => ({
    gameCode: state.datalab.gameCode,
    allPrivileges: state.privilegesConfig.allPrivileges,
  }), shallowEqual);
  const location = useLocation();
  useEffect(() => {
    buriedPoint({
      pageId: '601501',
      pageName: '主页',
      extInfo: `{"pageName": "Home", "pageNameCn": "主页", "id": ""}`,
      pagePath: '/Home',
      uid: gameCode,
      typeId: 'datalab_pc_v2',
      menuId: '0'
    });
  }, [gameCode]);

  /**
   * path 跳转路径
   * privileges 是页面访问的权限 editor_chart editor_dashboard之类的
   * isAccess 代表是否可以访问某个图表或报表 read, edit权限
   */
  
  const privilegesLink = useMemoizedFn((path: string, privileges: string[], isAccess = true) => {
    const hasPrivilege = privileges ? privileges?.some((item: string) => allPrivileges?.includes(item)) : true;
    if (isAccess && hasPrivilege) {
      history.push(`/datalab/${gameCode}${path}`);
    } else {
      // 弹出提示
      notification.error({
        description: <div style={{maxWidth: '600px'}}>
          <p>{formatMessage({ id: 'dbl_common_no_permission' })}</p>
          <p>{formatMessage({ id: 'dbl_common_no_permission_desc' })}</p>
        </div>,
      });
    }
  });
  
  return (
    <Layout className='dbl-home'
      key={location?.pathname}
    >
      <Body>
        <Content>
          <Content.Header title={formatMessage({id: 'dbl_home_header_title'})}/>
          <Content.Body full>
            <QuickAnalysis privilegesLink={privilegesLink}/>
            <GettingStart gameCode={gameCode} privilegesLink={privilegesLink}/>
            <RecentlyAndShare gameCode={gameCode} privilegesLink={privilegesLink}/>
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
}
